import classnames from "classnames";

import {TooltipWrapper} from "@/components/overlay/TooltipWrapper.tsx";

import css from "./CustomRow.module.css";

export interface CustomRowProps {
  text: string;
  tooltip?: string;
  className?: string;
}

export const CustomRow = ({text, className, tooltip}: CustomRowProps) => {
  return (
    <TooltipWrapper toolTip={tooltip}>
      <div
        className={classnames(
          "rounded rounded-2 my-2 p-3 d-flex align-items-center justify-content-center",
          css.CustomRow,
          className
        )}
      >
        <h2 className="w-100 text-center fw-semibold fs-5 p-0">{text}</h2>
      </div>
    </TooltipWrapper>
  );
};
